import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, validateYupSchema } from "formik";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import "./DeliveryForm.css"; // Import your CSS file
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import GeneralApiService from "../../services/generalServices";
import { setShowMessage } from "../../redux/slices/notificationSlice";
import moment from "moment";

// Validation schema with Yup
const DeliveryFormSchema = Yup.object().shape({
  customerName: Yup.string().required("Customer name is required"),
  enquiredDate: Yup.date().required("Enquired date is required"),
  village: Yup.string().required("Village is required"),
  taluka: Yup.string().required("Taluka is required"),
  district: Yup.string().required("District is required"),
  customerMobile: Yup.string().required("Customer mobile number is required"),
  whatsappNumber: Yup.string().required("WhatsApp number is required"),
  enquirySource: Yup.string().required("Enquiry Source is required"),
  reopenStatus: Yup.boolean(),
  createdby: Yup.string().required("Created By is required"),
  salesPerson: Yup.string().required("Sales person is required"),
  modelName: Yup.string().required("Model name is required"),
  invalid_date: Yup.date().required("Invalid date is required"),
  invalid_reason: Yup.string().required("Invalid reason is required"),
});

const InvalidForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ev_stage, editData } = location?.state;
  const [banklist, setBankList] = useState([]);
  const [modelslistByAgencyMake, setModelslistByAgencyMake] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [filterModelList, setFilterModelList] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [makeList, setMakeList] = useState([]);
  const [dspList, setDspList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [talukaList, setTalukaList] = useState([]);
  const [filterdTalukaList, setfilterdTalukaList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [filteredVillageList, setFileredVillageList] = useState([]);
  const [enquirySourceList, setEnqirySourceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({
    customerName: "",
    enquiredDate: null,
    village: "",
    taluka: "",
    district: "",
    customerMobile: "",
    whatsappNumber: "",
    enquirySource: "",
    reopenStatus: false,
    createdby: "",
    salesPerson: "",
    modelName: "",
    invalid_date: null,
    invalid_reason: "",
  });

  const fetchBankList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank-list`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);

      if (response.data?.isSuccess) {
        setBankList(
          response.data.result.map((item) => ({
            value: item.bankname,
            label: item.bankname,
          }))
        );
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCustomerDetails = async (customerId) => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/general/get-customerData/${customerId}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = await axios.get(url, config);

      if (response.data?.isSuccess) {
        const [rowData] = response.data.result.customerData;
        setCustomerData(rowData);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getVehicleMakeModels = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-make-modal-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    try {
      const response = await axios.get(url, config);
      if (response && response.data) {
        const {
          makeList,
          modelList,
          modelslistByAgencyMake,
          dspList,
          enquirySourceList,
          districtList,
          talukaList,
          villageList,
          
        } = response.data.result;
        setMakeList(
          makeList.map((item) => ({ value: item.id, label: item.name }))
        );
        setModelList(modelList);
        setModelslistByAgencyMake(
          modelslistByAgencyMake.map((item) => ({
            value: item.id,
            label: item.modalName,
          }))
        );
        setDspList(dspList);
        setEnqirySourceList(enquirySourceList);
        setDistrictList(districtList);
        setTalukaList(talukaList);
        setVillageList(villageList);
      } else {
        setMakeList([]);
        setModelList([]);
        setModelslistByAgencyMake([]);
        setDspList([]);
        setEnqirySourceList([]);
        setDistrictList([]);
        setTalukaList([]);
        setVillageList([]);
      }
    } catch (error) {
      console.error("Error fetching getVehicleMakeModels:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  useEffect(() => {
    if (editData && editData.id) {
      fetchCustomerDetails(editData.id);
    }
  }, [editData]);

  useEffect(() => {
    getVehicleMakeModels();
    fetchBankList();
  }, []);

  useEffect(() => {
    if (!loading && editData && customerData) {
      setInitialValues({
        customerName: customerData.customerName,
        enquiredDate: editData.enquiry_date
          ? moment(editData.enquiry_date).format("YYYY-MM-DD")
          : "",
        village: customerData.village,
        taluka: customerData.taluka,
        district: customerData.district,
        customerMobile: editData.phone_number,
        whatsappNumber: editData.whatsapp_number,
        enquirySource: customerData.enquiry_source_id,
        reopenStatus: false,
        createdby: customerData.user_created,
        salesPerson: customerData.salesperson_id,
        modelName: customerData.modal_id,
        invalid_date: customerData.invalid_date
          ? moment(customerData.invalid_date).format("YYYY-MM-DD")
          : "",
        invalid_reason: editData.invalid_reason,
      });

      setfilterdTalukaList(
        talukaList.filter((val) => val.district_id == customerData.district)
      );
      setFileredVillageList(
        villageList.filter((val) => val.taluka_id == customerData.taluka)
      );
      const filtered = modelList
        .filter((model) => model.manufacturerId == customerData.oldmake)
        .map((val) => ({ value: val.id, label: val.modalName }));

      setFilterModelList(filtered);
    }
  }, [loading, editData, customerData]);

  const formatType = (type) =>
    type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

  const handleSubmit = (values) => {
    try {
      values["editType"] = ev_stage.type;
      values["customerId"] = editData.id;
      const EditRequest = new GeneralApiService();
      EditRequest.editEnquiryStageRequest(values).then((response) => {
        if (response && response.success) {
          const formattedType = formatType(ev_stage.type);
          navigate(`/sale/data/${formattedType}`, {
            state: { stage: ev_stage },
          });
          dispatch(setShowMessage(response.message));
        }
      });
    } catch (error) {
      console.log(error, "Error submitting form");
    }
  };

  return (
    <Container className="bg-white rounded">
      <Row className="justify-content-md-center">
        <Col md={12}>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={DeliveryFormSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, values, touched, errors, setFieldValue }) => {
              const onDistrictChange = (e) => {
                const selectedDistrict = e.target.value;
                setFieldValue("district", selectedDistrict);
                setfilterdTalukaList(
                  talukaList.filter(
                    (val) => val.district_id == selectedDistrict
                  )
                );
              };
              const onTalukaChange = (e) => {
                const selectedTaluka = e.target.value;
                setFieldValue("taluka", selectedTaluka);
                setFileredVillageList(
                  villageList.filter((val) => val.taluka_id == selectedTaluka)
                );
              };

              return (
                <Form>
                  <Row className="mb-1">
                    <Col md={12}>
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="m-0 form-label">
                          EDIT{" "}
                          {ev_stage.type.charAt(0).toUpperCase() + ev_stage.type.slice(1)}
                        </label>

                        <Button
                          variant="outline-secondary"
                          className="text-muted mt-1"
                          size="small"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          BACK
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="customerName" className="form-label">
                        Name
                      </label>
                      <Field
                        name="customerName"
                        className="form-control"
                        type="text"
                      />
                      <ErrorMessage
                        name="customerName"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="customerMobile" className="form-label">
                        Phone Number
                      </label>
                      <Field
                        name="customerMobile"
                        className="form-control"
                        type="phone"
                      />
                      <ErrorMessage
                        name="customerMobile"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="whatsappNumber" className="form-label">
                        WhatsApp Number
                      </label>
                      <Field
                        name="whatsappNumber"
                        className="form-control"
                        type="phone"
                      />
                      <ErrorMessage
                        name="whatsappNumber"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="district" className="form-label">
                        District
                      </label>
                      <Field
                        as="select"
                        name="district"
                        className="form-control"
                        onChange={(e) => onDistrictChange(e)}
                      >
                        <option value="" label="Select District" />
                        {districtList.map((dist) => (
                          <option
                            key={dist.value}
                            value={dist.value}
                            label={dist.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="district"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="taluka" className="form-label">
                        Taluka
                      </label>
                      <Field
                        as="select"
                        name="taluka"
                        className="form-control"
                        onChange={(e) => onTalukaChange(e)}
                      >
                        <option value="" label="Select Taluka" />
                        {filterdTalukaList.map((taluka) => (
                          <option
                            key={taluka.value}
                            value={taluka.value}
                            label={taluka.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="taluka"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="village" className="form-label">
                        Village
                      </label>
                      <Field
                        as="select"
                        name="village"
                        className="form-control"
                      >
                        <option value="" label="Select Village" />
                        {filteredVillageList.map((village) => (
                          <option
                            key={village.value}
                            value={village.value}
                            label={village.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="village"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="enquiredDate" className="form-label">
                        Enquiry Date
                      </label>
                      <Field
                        name="enquiredDate"
                        className="form-control"
                        type="date"
                      />
                      <ErrorMessage
                        name="enquiredDate"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="invalid_date" className="form-label">
                        Invalid Date
                      </label>
                      <Field
                        name="invalid_date"
                        className="form-control"
                        type="date"
                      />
                      <ErrorMessage
                        name="invalid_date"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="enquirySource" className="form-label">
                        Enquiry Source
                      </label>
                      <Field
                        as="select"
                        name="enquirySource"
                        className="form-control"
                      >
                        <option value="" label="Select Enquiry Source" />
                        {enquirySourceList.map((eos) => (
                          <option
                            key={eos.value}
                            value={eos.value}
                            label={eos.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="enquirySource"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <label htmlFor="invalid_reason" className="form-label">
                        Invalid Reason
                      </label>
                      <Field
                        name="invalid_reason"
                        className="form-control"
                        type="text"
                      ></Field>
                      <ErrorMessage
                        name="invalid_reason"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>

                    <Col md={4}>
                      <label htmlFor="salesPerson" className="form-label">
                        Sales Person
                      </label>
                      <Field
                        as="select"
                        name="salesPerson"
                        className="form-control"
                      >
                        <option value="" label="Select Sales Person" />
                        {dspList.map((dsp) => (
                          <option
                            key={dsp.value}
                            value={dsp.value}
                            label={dsp.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="salesPerson"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                    <Col md={4}>
                      <label htmlFor="createdby" className="form-label">
                        Enquiry Ad
                      </label>
                      <Field
                        as="select"
                        name="createdby"
                        className="form-control"
                      >
                        <option value="" label="Select Enquiry Ad" />
                        {dspList.map((dsp) => (
                          <option
                            key={dsp.value}
                            value={dsp.value}
                            label={dsp.label}
                          />
                        ))}
                      </Field>
                      <ErrorMessage
                        name="createdby"
                        component={({ children }) => (
                          <span
                            style={{ color: "darkred", fontSize: "0.875rem" }}
                          >
                            {children}
                          </span>
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={8}>
                      <div className="form-check">
                        <Field
                          type="checkbox"
                          name="reopenStatus"
                          id="reopenStatus"
                          className="form-check-input"
                        />
                        <label
                          htmlFor="reopenStatus"
                          className="form-check-label"
                        >
                          Reopen Enquiry
                        </label>
                      </div>
                    </Col>
                  </Row>

                  {/* Save Changes */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <Button
                        variant="outline-primary"
                        className="px-5"
                        type="submit"
                        // disabled={isSubmitting}
                      >
                        Save Changes
                      </Button>

                      <Button
                        variant="outline-primary"
                        className=" ms-2 px-4"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export default InvalidForm;
